import * as React from 'react';
import { UIComponentHandler } from '../../../toolkit/uicomponent';
import { TransactionHistoryCSSStyle } from './transactionhistorylistcss';
import { BaseContext } from '../../../../utils/basecontext';
import { TransactionHistoryComponentProps} from './transactionhistorylistcomponent';
import { TransactionHistoryViewModelImpl } from './viewmodel/transactionhistoryviewmodel';
import { TransactionHistoryDto } from '../../../../core/dto/transactionhistory/transactionhistorydto';
import { Strings } from '../../../../utils/resources/strings';
import { CRBTUIViewImpl } from '../crbt/crbtuiview';
import { VerticalListComponent } from '../../../toolkit/verticallist/verticallistcomponent';
import { PopUpWrapperComponent } from '../../popup/popupwrappercomponent';
import { AlertType } from '../../../toolkit/alert/alerttype';
import { AlertComponent } from '../../../toolkit/alert/alertcomponent';
import { LoaderWrapperComponent } from '../../popup/loaderwrappercomponent';
import { LoaderComponent } from '../../../toolkit/loader/loadercomponent';
import { RoutingFeatures } from '../../navigation/routingfeature';
import {TransactionHistoryComponentState} from './transactionhistorylistcomponent';

export class TransactionHistoryViewImpl extends CRBTUIViewImpl
{
    private transactionViewModel: TransactionHistoryViewModelImpl;
    private popupComponent:PopUpWrapperComponent ;
    private loaderWrapperComponent:LoaderWrapperComponent;

    constructor(context: BaseContext, uiComponentHandler: UIComponentHandler)
    {
        super(context, uiComponentHandler);

        this.transactionViewModel = new TransactionHistoryViewModelImpl(4, context);
    }
    bindHandlers()
    {
        this.showPopup = this.showPopup.bind(this);
        this.hidePopup = this.hidePopup.bind(this);
        this.showLoader = this.showLoader.bind(this);
        this.dismissLoader = this.dismissLoader.bind(this);
        this.showInactiveSubscriberPopup  = this.showInactiveSubscriberPopup.bind(this);
        this.confirmClick = this.confirmClick.bind(this);

    }
    getChildComponent(props: TransactionHistoryComponentProps, state: TransactionHistoryComponentState, cssStyle: TransactionHistoryCSSStyle): JSX.Element
    {
        
        console.log("---tiger"+props.context.getUserContext().getPackName());
        return (
            
            
            <div style={cssStyle.getWrapperCSSStyle()}>
              
               <VerticalListComponent listViewModel={this.transactionViewModel} context={props.context}/>
               
               <PopUpWrapperComponent ref={(item: any) => this.popupComponent = item} context={props.context}/>
        <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>
            </div>
        );
    }

    getNavigationPath()
    {
        return [this.getUIProps().context.getResources().getString(Strings.myaccount), this.getUIProps().context.getResources().getString(Strings.history)];
    }

    getBannerImg()
    {
        return "search.jpg";
    }
    confirmClick()
    {
        this.hidePopup();
        this.getUIProps().context.getRedirectionHandler().routeNextFeature(RoutingFeatures.HOME, false);
    }
    showInactiveSubscriberPopup()
    {
     this.popupComponent !== null && this.popupComponent.setShowWindow(true, <AlertComponent buttonTitle={this.getUIProps().context.getResources().getString(Strings.ok)} alertMessage={this.getUIProps().context.getResources().getString(Strings.no_history)} alertType={AlertType.WARN} onCloseButtonClick={this.confirmClick} onClick={this.confirmClick} context={this.getUIProps().context}/>);
    }
    showLoader()
    {
       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }

    showPopup(msg: string, type: AlertType,title:string)
    {
        
        this.popupComponent !== null && this.popupComponent.setShowWindow(true, <AlertComponent buttonTitle={title} alertMessage={msg} alertType={type} onCloseButtonClick={this.confirmClick} onClick={this.confirmClick} context={this.getUIProps().context}/>);
    }
    hidePopup()
    { 
        this.popupComponent !== null && this.popupComponent.setShowWindow(false, <></>);
    }
    setListOfDatas(listofTones: TransactionHistoryDto[])
    {
        this.transactionViewModel.setListDatas(listofTones);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/transactionhistory/transactionhistorylistview.tsx